import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import TestModePage from "./TestModePage.jsx";
import ProdModePage from "./ProdModePage.jsx";
import axios from 'axios';

const APITab = () => {
  const [currentPage, setCurrentPage] = useState("test");

  useEffect(async () => {
    const response = await axios.get("/user/resources/access-keys?target=prod")

    if(response && Array.isArray(response.data) && response.data.length > 0){
      setCurrentPage("prod");
    }
  }, []);
  
  

  const renderPage = () => {
    switch (currentPage) {
      case "test":
        return <TestModePage setCurrentPage={setCurrentPage}/>;
      case "prod":
        return <ProdModePage setCurrentPage={setCurrentPage}/>;
    }
  }



  return (
    <>
      { renderPage() }
    </>
  );
};

export default APITab;
